export const drugUseRows = [
  { name: "Cannabis (Weed, Skunk, Grass, THC Vape)", prescribed: true },
  { name: "Cannabidiol (CBD)", prescribed: true },
  { name: "Powder Cocaine", prescribed: false },
  { name: "Crack Cocaine", prescribed: false },
  { name: "MDMA (Ecstasy, E)", prescribed: false },
  { name: "Amphetamine (Fet, Speed and including certain medications e.g. Elvanse, Lisdexamphetamine)", prescribed: true },
  { name: "Methamphetamine (Meth, Crystal)", prescribed: false },
  { name: "Ketamine (Ket, Special K)", prescribed: true },
  { name: "Heroin (Diamorphine - pharmaceutical grade heroin)", prescribed: true },
  { name: "'Spice' (Synthetic Cannabinoids)", prescribed: false },
  { name: "Codeine (including co-codamol)", prescribed: true },
  { name: "Dihydrocodeine (including co-dyramol and paramol)", prescribed: true },
  { name: "Morphine", prescribed: true },
  { name: "Oxycodone (including oxymorphone)", prescribed: true }, 
  { name: "Diazepam (including nordiazepam)", prescribed: true },
  { name: "Other Benzodiazepines (please specify below)", prescribed: true },
  { name: "Amitriptyline", prescribed: true },
  { name: "Pregabalin", prescribed: true },
  { name: "Gabapentin", prescribed: true },
  { name: "Buprenorphine", prescribed: true },
  { name: "Methadone", prescribed: true },
  { name: "Tramadol", prescribed: true },
  { name: "Other illicit substances not listed", prescribed: false },
];
